import * as NavActions from '../../../store/customers/nav/customers.nav.actions';

import * as Actions from './customers.filtering.actions';
import * as StateHelper from './customers-filtering.reducer-helper';

const initialState = {
  savedFilterViews: [],
  defaultFilterView: StateHelper.getDefaultFilterView(),
  activeFilterViewId: StateHelper.getDefaultFilterView().filterViewId,
  customFilterView: undefined,
};

export const customersFilterReducer = (state = initialState, action) => {
  const { savedFilterViews, filterViewId, filterView, appliedFilters, propName, propValue } = action;
  switch (action.type) {
    case Actions.CUSTOMERS_SWITCH_FILTERVIEW: {
      return {
        ...state,
        activeFilterViewId: filterViewId,
      };
    }
    case Actions.CUSTOMERS_AUTOSWITCH_FILTERVIEW_CUSTOM: {
      const newCustomView = StateHelper.createCustomFilterView(filterView, appliedFilters);
      return {
        ...state,
        customFilterView: newCustomView,
        activeFilterViewId: newCustomView.filterViewId,
      };
    }
    case NavActions.CUSTOMERS_SEARCH:
    case Actions.CUSTOMERS_AUTOSWITCH_FILTERVIEW_DEFAULT: {
      return {
        ...state,
        activeFilterViewId: state.defaultFilterView.filterViewId,
        customFilterView: undefined,
      };
    }
    case Actions.CUSTOMERS_CHANGE_CUSTOM_FILTERVIEW_PROP: {
      const updatedCustomView = StateHelper.updateCustomViewProp(propName, propValue, state.customFilterView);
      return {
        ...state,
        customFilterView: updatedCustomView,
      };
    }
    case Actions.CUSTOMERS_CHANGE_FILTERVIEW_PROP: {
      return {
        ...state,
        savedFilterViews: StateHelper.replaceUpdatedFilterView(propName, propValue, filterViewId, state.savedFilterViews),
      };
    }
    case Actions.CUSTOMERS_GET_SAVED_FILTERVIEWS_SUCCESS: {
      return {
        ...state,
        savedFilterViews: savedFilterViews.filter((view) => view.gridConfigTypeId === 'customer'),
      };
    }
    case Actions.CUSTOMERS_SAVE_NEW_FILTERVIEW_SUCCESS:
    case Actions.CUSTOMERS_SAVE_EXISTING_FILTERVIEW_SUCCESS: {
      return {
        ...state,
        customFilterView: undefined,
        activeFilterViewId: filterView.filterViewId,
        savedFilterViews: [...state.savedFilterViews.filter((view) => view.filterViewId !== filterView.filterViewId), filterView],
      };
    }
    case Actions.CUSTOMERS_DELETE_FILTERVIEW_SUCCESS: {
      return {
        ...state,
        savedFilterViews: state.savedFilterViews.filter((savedView) => savedView.filterViewId !== filterView.filterViewId),
        activeFilterViewId: state.defaultFilterView.filterViewId,
      };
    }
    default:
      return state;
  }
};

export { namespace } from './customers.filtering.reducer.metadata';
